// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
import { createSelector } from "reselect"
import type { FetchedCurrencies } from "@kiwicom/nitro/lib/records/Currency"

type State = {
  currencies: FetchedCurrencies
}

export default function CurrenciesReducer(
  state: FetchedCurrencies | null | undefined = {},
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action: any,
) {
  switch (action.type) {
    default:
      return state
  }
}

export const getCurrencies = (state: State) => state.currencies

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getCurrenciesKeys: any = createSelector(getCurrencies, Object.keys)
